<template>
  <el-dialog
    title="携带人员"
    :visible.sync="formVisible"
    width="600px"
    :close-on-click-modal="false"
  >
    <div class="carry-box">
      <p v-for="(item, index) in list" :key="index">
        {{ item.realName }}（{{ item.relationship }}）{{
          item.sex === 1 ? "男" : item.sex === 2 ? "女" : ""
        }}<br /><span>手机号 {{ item.mobile }}</span>
      </p>
    </div>
  </el-dialog>
</template>

<script>
import meetingSignUpCarryPeopleApi from "@/api/meeting/meetingSignUpCarryPeople";
export default {
  data() {
    return {
      list: [],
      formVisible: false,
      query: {
        pageNo: 1,
        pageSize: 10000
      }
    };
  },
  created() {},
  methods: {
    handleCarryPeople(row) {
      console.log(row.signUpNo);
      this.query.signNo = row.signUpNo;
      this.query.isGetTransportation = false;
      meetingSignUpCarryPeopleApi.fetchListTeev2(this.query).then(data => {
        this.list = data.data;
        this.formVisible = true;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.carry-box {
  p {
    font-size: 16px;
    color: #000f29;
    width: 49%;
    display: inline-block;
    margin: 0;
    padding-bottom: 20px;
    line-height: 22px;
    span {
      color: #666666;
    }
  }
}
</style>
